import { isSilencedByBoundary } from 'settle-ui/components/ContentErrorBoundary/helpers/isSilencedByBoundary/isSilencedByBoundary'

interface IsReactBoundarySilencedErrorParams {
  source: string
  error: unknown
}

/**
 * True when a RUM `source: console` error is React's own re-log of a boundary-caught error that
 * the boundary already handled without reporting — an expected not-found, or a 401 whose `/login`
 * redirect the Apollo error link owns. `error` is the original thrown value from the RUM
 * error-event domain context, not the serialized event message.
 */
export const isReactBoundarySilencedError = ({ source, error }: IsReactBoundarySilencedErrorParams): boolean =>
  source === 'console' && isSilencedByBoundary(error)
